const prodServiceFunctionsKey = '39kA3BjI4vyX8p0cTd/edrMaigJ3sOAbnmgvE8lSOz9rsXZr7VZ2vQ==';
const prodAppFunctionsKey = 'iMqec1xP7EGR1s8ZOnDIu1emgwCl0kAqWIKf6b5STHmCcrWxXQzs9g==';
const baseUrls = {
    SERVICE_FUNCTIONS: process.env.NODE_ENV === 'production'? 'https://majestyhouseservicedata.azurewebsites.net' : 'http://localhost:7071',
    APP_FUNCTIONS: process.env.NODE_ENV === 'production'? 'https://majestyhouseappfunctions.azurewebsites.net' : 'http://localhost:7072',
}

const getServiceFunctionsKey = () => process.env.NODE_ENV === 'production' ? prodServiceFunctionsKey : '';
const getAppFunctionsKey = () => process.env.NODE_ENV === 'production' ? prodAppFunctionsKey : '';

const urls = {
    AUTHENTICATION_URL: `${baseUrls.SERVICE_FUNCTIONS}/api/Authenticate?code=${getServiceFunctionsKey()}`,
    SERVICES_URL: `${baseUrls.SERVICE_FUNCTIONS}/api/GetServices?code=${getServiceFunctionsKey()}`,
    GET_PRAYER_REQUESTS: `${baseUrls.APP_FUNCTIONS}/api/GetPrayerRequests?code=${getAppFunctionsKey()}`,
    UPDATE_PRAYER_REQUEST_STATUS: `${baseUrls.APP_FUNCTIONS}/api/UpdatePrayerRequestStatus?code=${getAppFunctionsKey()}`,
    GET_TESTIMONIES: `${baseUrls.APP_FUNCTIONS}/api/GetTestimonies?code=${getAppFunctionsKey()}`,
    UPDATE_TESTIMONY_STATUS: `${baseUrls.APP_FUNCTIONS}/api/UpdateTestimonyStatus?code=${getAppFunctionsKey()}`,
    SEND_NOTIFICATION: `${baseUrls.APP_FUNCTIONS}/api/SendNotification?code=${getAppFunctionsKey()}`,    
    GET_INTERPRETATIONS: `${baseUrls.SERVICE_FUNCTIONS}/api/GetInterpretations?code=${getServiceFunctionsKey()}`,
    ADD_INTERPRETATION: `${baseUrls.SERVICE_FUNCTIONS}/api/AddInterpretation?code=${getServiceFunctionsKey()}`,
    REMOVE_INTERPRETATION: `${baseUrls.SERVICE_FUNCTIONS}/api/RemoveInterpretation?code=${getServiceFunctionsKey()}`,
    GET_VIDEO: `${baseUrls.SERVICE_FUNCTIONS}/api/GetVideo?code=${getServiceFunctionsKey()}`,
    GET_VIDEO_SUBTITLES: `${baseUrls.SERVICE_FUNCTIONS}/api/GetVideoSavedSubtitles?code=${getServiceFunctionsKey()}`,
}


export default urls;